import React from 'react';
import * as Yup from 'yup';
import { Grid } from '@mui/material';
import {
  SparkForm,
  SparkTextField,
  SparkFormButton,
} from 'sharedComponents/SparkForm';
import { useForgotPassword } from 'hooks/auth';
import { useNavigate } from 'react-router-dom';
import { SPARK_ROUTES } from 'constants/routes';

type ForgetPasswordFormValues = {
  email: string;
};

const initialValues = {
  email: '',
};
const validationSchema = Yup.object({
  email: Yup.string()
    .required('Email is Required')
    .email('Please enter a valid Email'),
});

function ForgetPassword() {
  const { mutateAsync: sendEmail, isLoading } = useForgotPassword();
  const navigate = useNavigate();

  const handleLogin = async (values: ForgetPasswordFormValues) => {
    await sendEmail(values);
    navigate(SPARK_ROUTES.LOGIN);
  };

  return (
    <SparkForm
      initialValues={initialValues}
      onSave={handleLogin}
      validationSchema={validationSchema}
    >
      <SparkTextField
        name='email'
        label='Email'
        size={12}
        placeholder='Enter Email'
        autoLowerCase={true}
      />

      <Grid item container justifyContent='center'>
        <SparkFormButton
          disabled={isLoading}
          disabledMessage={isLoading ? 'Loading...' : ''}
          sx={{
            padding: 2,
            textDecoration: 'none',
            fontSize: '14px',
          }}
        >
          Send Link
        </SparkFormButton>
      </Grid>
    </SparkForm>
  );
}

export default ForgetPassword;
